import { Link } from "react-router-dom";
import { Card, Container, Row, Col } from "react-bootstrap";

const AdminDashboard = () => {
  return (
    <Container className="mt-5">
      <h2 className="text-center mb-4">Адмін Панель</h2>
      <Row className="justify-content-center">
        <Col md={4} className="mb-3">
          <Card>
            <Card.Img variant="top" src="./images/admin/users.png" style={{ maxHeight: "200px", objectFit: "cover" }} />
            <Card.Body>
              <Card.Title>Користувачі</Card.Title>
              <Card.Text>Перегляд та управління користувачами</Card.Text>
              <Link to="/admin/users" className="btn btn-primary">
                Відкрити
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-3">
          <Card>
            <Card.Img variant="top" src="./images/admin/users.png" style={{ maxHeight: "200px", objectFit: "cover" }} />
            <Card.Body>
              <Card.Title>Додати надходження</Card.Title>
              <Card.Text>Завантаження нових даних</Card.Text>
              <Link to="/admin/upload-incomings" className="btn btn-primary">
                Відкрити
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-3">
          <Card>
            <Card.Img variant="top" src="./images/admin/users.png" style={{ maxHeight: "200px", objectFit: "cover" }} />
            <Card.Body>
              <Card.Title>Додати користувача</Card.Title>
              <Card.Text>Створення нового користувача</Card.Text>
              <Link to="/admin/addnewuser" className="btn btn-primary">
                Відкрити
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-3">
          <Card>
            <Card.Img variant="top" src="./images/admin/users.png" style={{ maxHeight: "200px", objectFit: "cover" }} />
            <Card.Body>
              <Card.Title>Рапорти</Card.Title>
              <Card.Text>Рапорти про роботу водіїв</Card.Text>
              <Link to="/admin/driver-raport" className="btn btn-primary">
                Відкрити
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-3">
          <Card>
            <Card.Img variant="top" src="./images/admin/debts.jpg" style={{ maxHeight: "200px", objectFit: "cover" }}/>
            <Card.Body>
              <Card.Title>Борги</Card.Title>
              <Card.Text>Борги водіїв</Card.Text>
              <Link to="/admin/driver-debts" className="btn btn-primary">
                Відкрити
              </Link>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4} className="mb-3">
          <Card>
            <Card.Img variant="top" src="./images/admin/debts.jpg" style={{ maxHeight: "200px", objectFit: "cover" }}/>
            <Card.Body>
              <Card.Title>Додаткові витрати</Card.Title>
              <Card.Text>повернення ПДВ, податки ZUS, виплати партнеру ,витрати на бухгалтера, оренда авто, інші витрати, повернення коштів</Card.Text>
              <Link to="/admin/driver-extra-funds" className="btn btn-primary">
                Відкрити
              </Link>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AdminDashboard;
